export const CYCLE_STATUS_LABELS = {
  inProgress: 'In progress',
  canceled: 'Canceled',
  connected: 'Connected',
  acknowledged: 'Acknowledged',
  noResponse: 'No response',
  unknown: 'Unknown',
} as const;

export type CycleStatusKey = keyof typeof CYCLE_STATUS_LABELS;

export const CYCLE_STATUS_DESCRIPTIONS: Record<CycleStatusKey, string> = {
  inProgress: 'Active alert cycle, retries pending...',
  acknowledged: 'A person answered the call, or the contact replied 1 to the text.',
  connected: 'The contact pressed 0 and was connected to the callback location.',
  canceled: 'This alert was stopped by a User.',
  noResponse: 'All retries finished and nobody answered or replied.',
  unknown: 'Could not tell how this alert cycle ended.',
};

export const CYCLE_STATUS_LEGEND: { key: CycleStatusKey; label: string; description: string }[] = [
  'inProgress',
  'acknowledged',
  'connected',
  'canceled',
  'noResponse',
  'unknown',
].map((key) => {
  const status = key as CycleStatusKey;
  return {
    key: status,
    label: CYCLE_STATUS_LABELS[status],
    description: CYCLE_STATUS_DESCRIPTIONS[status],
  };
});

export function cycleStatusLabel(status: string | undefined): string {
  if (status && status in CYCLE_STATUS_LABELS) {
    return CYCLE_STATUS_LABELS[status as CycleStatusKey];
  }
  return status || CYCLE_STATUS_LABELS.unknown;
}

export function cycleStatusBadgeVariant(
  status: string | undefined,
): CycleStatusKey {
  if (status && status in CYCLE_STATUS_LABELS) {
    return status as CycleStatusKey;
  }
  return 'unknown';
}
